"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModifyUserAliasEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class ModifyUserAliasEvent extends web_ui_framework_1.Event {
}
exports.ModifyUserAliasEvent = ModifyUserAliasEvent;
//# sourceMappingURL=userAliasEvents.js.map